// Función debounce
export function debounceSearch(func, timeout = 300) {
  window.debounceTimerSearch;
  return (...args) => {
    clearTimeout(window.debounceTimerSearch);
    window.debounceTimerSearch = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
export function debounceLoadMarker(func, timeout = 300) {
  window.debounceTimerLoadMarker;
  return (...args) => {
    clearTimeout(window.debounceTimerLoadMarker);
    window.debounceTimerLoadMarker = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
